module.exports = __webpack_public_path__ + "static/media/hilbi-logo-hover.6cb0d29f.svg";